import { Meteors } from "@stianlarsen/meteors";
import { Link } from "react-router-dom";
import "../ProjectContainer/ProjectContainer.css";
import "./Projects.css";

export default function Projects() {
  return (
    <div id="blogs" className="blogs" style={{ position: "relative" }}>
      <h2 className="section__title about_project">Blogs</h2>
      <Meteors
        speed={0.1}
        size={20}
        amount={2}
        colorLightmode="#2978b5"
        colorDarkmode="white"
        fallingSide="left"
      />

      <div className="cards">
        <img src={"/images/cards/1.png"} alt="" />
        <img src={"/images/cards/2.png"} alt="" />
        <img src={"/images/cards/3.png"} alt="" />
      </div>

      <p className="project_subtitle">
        I believe detailed case studies reveal a developer's true technical
        ability. That is why I have documented each of my blogs in depth.
      </p>

      <Link
        to="/blogs"
        className="hero-resume-btn"
        style={{ marginTop: "10px", fontFamily: "Montserrat" }}
      >
        <span
          className="btn btn--hero"
          style={{ fontWeight: "600" }}
        >
          View All Blogs
        </span>
      </Link>
    </div>
  );
}
